import { AvtGateway, HttpRequest } from '../../../kernel/avt.gateway'
import { convertArraySnakeCaseToCamelCaseProperties } from '../../../kernel/mappers'
import { ItemRepository } from '../domain/item.repository'
import { ItemChanges, JobItem } from '../domain/items'

export const itemRepository: ItemRepository = {
  getItemsByJob: async (jobId: string): Promise<JobItem[]> => {
    const request: HttpRequest = {
      method: 'GET',
      endpoint: `/odin/api/job/${jobId}/items`
    }

    const result = await AvtGateway.executeGetRequest(request)

    const items: JobItem[] = convertArraySnakeCaseToCamelCaseProperties(result)

    return items
  },
  getItemChanges: async (jobId: string): Promise<ItemChanges[]> => {
    const request: HttpRequest = {
      method: 'GET',
      endpoint: `/odin/api/job/${jobId}/item-changes`
    }

    const result = await AvtGateway.executeGetRequest(request)

    const items: ItemChanges[] = convertArraySnakeCaseToCamelCaseProperties(result)

    return items
  }
}
